import { Route, Routes } from 'react-router-dom';

import { InvitationStatusScreen } from './components';
import { LINK_STATE } from './constants/invitationStates.js';
import AcceptInvitationPage from './pages/AcceptInvitationPage';

/**
 * PUBLIC routes of the recipient-side invitation flow. Mount them OUTSIDE any auth guard at
 * `invitations/*` (the link in the email is `/invitations/:token`): the recipient must be able to
 * open the link before having a session. The host owns authentication and passes it in.
 *
 * @param {object} props
 * @param {boolean} props.isAuthenticated
 * @param {boolean} props.authLoading
 * @param {string} [props.loginPath='/login']
 * @param {string|null} [props.signedInEmail] Email of the session (optional).
 * @param {() => void} [props.onSignOut] Host sign-out (optional).
 */
function InvitationRoutes({ isAuthenticated, authLoading, loginPath, signedInEmail, onSignOut }) {
  return (
    <Routes>
      <Route
        path=":token"
        element={
          <AcceptInvitationPage
            isAuthenticated={isAuthenticated}
            authLoading={authLoading}
            loginPath={loginPath}
            signedInEmail={signedInEmail}
            onSignOut={onSignOut}
          />
        }
      />
      <Route path="*" element={<InvitationStatusScreen variant={LINK_STATE.INVALID} />} />
    </Routes>
  );
}

export default InvitationRoutes;
